import { TagComponent } from 'ecsy'

export default class SunOrientationTagComponent extends TagComponent {}
